import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_BLOG_HOME_PAGE } from 'mocks/queries';
import useIsRefreshCache from 'hooks/useIsRefreshCache';

const useBlogHomePage = ({ blogUrl }) => {
  const isRefreshCache = useIsRefreshCache();

  const { loading, data, error } = useSuspenseQuery(GET_BLOG_HOME_PAGE, {
    variables: {
      blogUrl,
    },
    fetchPolicy: isRefreshCache ? 'network-only' : 'cache-first',
  });

  return {
    loading,
    data: data?.getBlogHomePage,
    error: error || data?.getBlogHomePage?.errors?.[0]?.message,
  };
};

export default useBlogHomePage;
